import { ChangeDetectionStrategy, booleanAttribute, Component, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

/**
 * An on/off filter, e.g. "Kun ikke godkendte". Off: outlined with `add`. On: tonal green with a
 * check — a second click turns it off again.
 */
@Component({
  selector: 'abook-toggle-chip',
  imports: [MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[class.is-changed]': 'checked()' },
  template: `
    <button
      type="button"
      class="toggle"
      [class.toggle--on]="checked()"
      [class.toggle--compact]="compact()"
      [attr.aria-pressed]="checked()"
      (click)="checkedChange.emit(!checked())"
    >
      <mat-icon aria-hidden="true">{{ checked() ? 'check' : 'add' }}</mat-icon>
      {{ label() }}
    </button>
  `,
  styleUrl: './abook-toggle-chip.component.scss',
})
export class AbookToggleChipComponent {
  readonly label = input.required<string>();
  readonly checked = input(false, { transform: booleanAttribute });
  readonly compact = input(false, { transform: booleanAttribute });
  readonly checkedChange = output<boolean>();
}
